<template>
  <BaseOption>
    <template v-slot:body>
      <div class="main-card mb-3 card account-options">
        <div class="card-header">
          Sales Account
          <div class="btn-actions-pane-right">
            <button type="submit" class="btn btn-primary" @click.stop.prevent="handleClickSave">Save</button>
          </div>
        </div>
        <div class="card-body">
          <div class="row position-relative form-group col-12">
            <label class="col-12 card-title mb-0 p-0">Next Time</label>
            <NextTime :config="{ schedules: data?.['sale-account']?.schedules, values: Object.assign({}, values?.['sale-account']?.schedules) }" @changeValue="changeSaleAccountScheduleValue"></NextTime>
          </div>
          <div class="row position-relative form-group col-12">
            <label class="col-12 card-title mb-0 p-0">Storage</label>
            <div class="col-12 btn-group-sm nav btn-group mt-2 d-inline-block">
              <div v-for="(object, index) in data?.['sale-account']?.use_internal_storage" :key="index" class="radio-container btn-shadow btn btn-primary show p-0">
                <input type="radio" name="account[use_internal_storage]" :value="index" :checked="values?.['sale-account']?.use_internal_storage == index" @change="store.commit('values.sale-account.use_internal_storage', $event.target.value)" />
                <span href="#" class="checkmark d-inline-block p-2">{{ object.label }}</span>
              </div>
            </div>
            <small>Save media to the internal system</small>
          </div>
        </div>
      </div>
    </template>
  </BaseOption>
</template>

<script>
import Event from '@/helper/event.js'
import BaseOption from '@/views/Option/BaseOption.vue'
import NextTime from '@/views/Option/NextTime.vue'
export default {
  mixins: [Event],
  components: {
    BaseOption,
    NextTime
  },
  computed: {
    storeId() {
      return 'main'
    },
    indexUri() {
      return 'account/option'
    },
    submitUri() {
      return 'account/option/update'
    },
    data() {
      return this.store.getter('data', {})
    },
    values() {
      return this.store.getter('values', {})
    }
  },
  methods: {
    setUpData({ status, data }) {
      if (status != 'success') return
      this.store.commit('', data)
    },
    changeSaleAccountScheduleValue(e) {
      this.store.commit('values.sale-account.schedules', e)
    },
    handleClickSave() {
      this.submitForm(this.store.getter('values', {}))
    }
  }
}
</script>
